export const LoadingStatusMap = {
  INIT: 'INIT',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  UPDATE: 'UPDATE',
  ERROR: 'ERROR',
};